/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SettingsDto,
    SettingsDtoFromJSON,
    SettingsDtoToJSON,
} from '../models';

/**
 * 
 */
export class SettingsApi extends runtime.BaseAPI {

    /**
     */
    async settingsGetRaw(): Promise<runtime.ApiResponse<SettingsDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("oauth2", []);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/api/v2/dashboard/settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SettingsDtoFromJSON(jsonValue));
    }

    /**
     */
    async settingsGet(): Promise<SettingsDto> {
        const response = await this.settingsGetRaw();
        return await response.value();
    }

}
